module.exports = __webpack_public_path__ + "static/media/1.2b5e5c83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/81045/1.jpg
// module id = 836
// module chunks = 0